import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import DecimalInput from "@Shared/components/inputs/decimal-input";
import CurrencyInput from "@Shared/components/inputs/currency-input";
import PhoneInput from "@Shared/components/inputs/phone-input";
import AddressInput from "@Shared/components/inputs/address-input";
import BaseInput from "@Shared/components/inputs/base-input";
import CustomDropdownField from "./custom-dropdown-field";
import { email } from "vuelidate/lib/validators";
import { validDate } from "@Shared/@Utils/validation-rules";
import { validationMixin } from "vuelidate";
import VuelidateValid from "@Shared/utils/shared-mixins/vuelidate-valid-mixin";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import { throttle } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CustomDataField",
  components: {
    DecimalInput,
    MaterialInput,
    CurrencyInput,
    PhoneInput,
    AddressInput,
    BaseInput,
    CustomDropdownField,
    DatepickerInput
  },
  mixins: [validationMixin, VuelidateValid],
  validations() {
    const rules = {};
    if (this.type === "email") rules.email = email;
    if (this.type === "date") rules.validDate = validDate;
    return {
      valueModel: rules
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    name: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator(value) {
        const validTypes = ["text", "numeric", "monetary", "phone", "date", "address", "email", "dropdown"];
        return _includesInstanceProperty(validTypes).call(validTypes, value);
      }
    },
    value: {
      type: null,
      required: true
    },
    orphaned: {
      type: Boolean,
      default: false
    },
    customFieldDefinition: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      labelValue: uuidv4()
    };
  },
  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set: throttle(function (value) {
        const {
          id,
          name,
          type,
          orphaned
        } = this;
        this.$emit("change", {
          id,
          name: name.key,
          type,
          orphaned,
          value: value && type === "email" ? value.toLowerCase() : value || null
        });
      }, 100, {
        leading: true
      })
    },
    parsedValue() {
      var _this$value, _this$customFieldDefi, _this$customFieldDefi2, _this$customFieldDefi3, _context;
      switch (this.type) {
        case "address":
          return (_this$value = this.value) == null ? void 0 : _this$value["formatted-address"];
        case "dropdown":
          return (_this$customFieldDefi = this.customFieldDefinition) == null ? void 0 : (_this$customFieldDefi2 = _this$customFieldDefi.options) == null ? void 0 : (_this$customFieldDefi3 = _findInstanceProperty(_context = _this$customFieldDefi2.items).call(_context, ({
            id
          }) => id === this.value)) == null ? void 0 : _this$customFieldDefi3.name;
        default:
          return this.value;
      }
    },
    isTextField() {
      const textFieldTypes = ["text", "email"];
      return _includesInstanceProperty(textFieldTypes).call(textFieldTypes, this.type);
    },
    isDropdownField() {
      return this.type === "dropdown";
    },
    componentFromType() {
      const map = {
        text: BaseInput,
        email: BaseInput,
        numeric: DecimalInput,
        monetary: CurrencyInput,
        phone: PhoneInput,
        address: AddressInput,
        dropdown: CustomDropdownField,
        date: DatepickerInput
      };
      return map[this.type];
    },
    selectOptions() {
      var _this$customFieldDefi4, _this$customFieldDefi5;
      return this.isDropdownField ? (_this$customFieldDefi4 = this.customFieldDefinition) == null ? void 0 : (_this$customFieldDefi5 = _this$customFieldDefi4.options) == null ? void 0 : _this$customFieldDefi5.items : [];
    }
  },
  methods: {
    handleChange(event) {
      var _ref, _event$target$value, _event$target;
      this.valueModel = (_ref = (_event$target$value = event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value) != null ? _event$target$value : event == null ? void 0 : event.value) != null ? _ref : event;
    }
  }
});